import React from 'react';
import PropTypes from 'prop-types';
import { SectionDescriptionWithImage } from 'components/Sections/SectionDescriptionWithImage';
import { WebsiteImage, DescriptionWithIcon } from 'components/TitleDescription';
import { CircleCheckboxIcon } from 'components/Brand/Icons/CircleCheckboxIcon';
import VideoButton from 'components/Video/VideoButton';
import TwoImageOverlap from 'components/TwoImageOverlap';

import { StyledButton } from './styles';

const CalloutSection = props => {
  const {
    title,
    subhead,
    descriptionOne,
    descriptionTwo,
    descriptionThree,
    circleCheckBoxIconColor,
    videoButton,
    videoUrl,
    imgOne,
    imgTwo,
    layoutType,
    backgroundColor,
    cta,
  } = props;

  return (
    <SectionDescriptionWithImage
      titlePart={
        <div>
          {title && <h2>{title}</h2>}
          {subhead && <p>{subhead}</p>}
        </div>
      }
      descriptionOnePart={
        descriptionOne ? (
          <DescriptionWithIcon iconImage={<CircleCheckboxIcon color={circleCheckBoxIconColor} />}>
            {descriptionOne}
          </DescriptionWithIcon>
        ) : null
      }
      descriptionTwoPart={
        descriptionTwo ? (
          <DescriptionWithIcon iconImage={<CircleCheckboxIcon color={circleCheckBoxIconColor} />}>
            {descriptionTwo}
          </DescriptionWithIcon>
        ) : null
      }
      descriptionThreePart={
        descriptionThree ? (
          <>
            <DescriptionWithIcon iconImage={<CircleCheckboxIcon color={circleCheckBoxIconColor} />}>
              {descriptionThree}
            </DescriptionWithIcon>
          </>
        ) : null
      }
      descriptionAdditionalPart={
        videoButton ? (
          <VideoButton
            mainSrc={videoUrl}
            title={'Play Video'}
            color="blue"
            style={{ marginTop: '70px' }}
          />
        ) : null
      }
      imagePart={
        <TwoImageOverlap
          image1={<WebsiteImage src={imgOne} width="auto" />}
          image2={<WebsiteImage src={imgTwo} width="auto" />}
          width="100%"
          reversed={layoutType === 'Text Side Images Side' ? false : true}
        ></TwoImageOverlap>
      }
      reversed={layoutType === 'Text Side Images Side' ? false : true}
      backgroundColor={backgroundColor}
      cta={cta}
    />
  );
};

CalloutSection.propTypes = {
  title: PropTypes.string,
  subhead: PropTypes.string,
  descriptionOne: PropTypes.string,
  descriptionTwo: PropTypes.string,
  descriptionThree: PropTypes.string,
  layoutType: PropTypes.string,
  videoUrl: PropTypes.string,
  imgOne: PropTypes.object,
  imgTwo: PropTypes.object,
  videoButton: PropTypes.bool,
  backgroundColor: PropTypes.string,
};

export default CalloutSection;
